import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';
import { scrollTo } from '../utils/scrollTo';

const Hero = () => {
  const { t, lang } = useLanguage();

  const trackContact = (actionName) => {
    if (window.fbq) {
      window.fbq('track', 'Contact', {
        language: lang,
        action: actionName
      });
    }
  };

  return (
    <section id="home" className="relative pt-24 pb-12 md:pt-32 md:pb-20 lg:pt-40 lg:pb-28 overflow-hidden min-h-[90vh] flex items-center">
      <div className="absolute inset-0 z-0 bg-slate-900">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/93693806e52d557505bcda151baedfc511d2a8846f04584b1cb3f9d6077d8cb7ad67425a4311fb1bee70aa0e3387aa1d/images/aW1hZ2UvcG5n/4a6ea99184e24cad8b73065a5304879b.png" 
          alt="Updated kitchen view" 
          className="w-full h-full object-cover object-center opacity-80" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/30 to-slate-900/10"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/50 to-transparent"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="max-w-3xl">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6 }}
          >
            <div className="flex flex-col gap-3 mb-8">
              <div className="inline-flex w-fit items-center rounded-full bg-red-600 px-4 py-2 text-sm font-bold uppercase tracking-wider text-white shadow-lg">
                <SafeIcon name="CheckCircle" className="w-5 h-5 mr-2" />
                {lang === 'es' ? 'Esta propiedad está alquilada' : 'This property is rented'}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="Home" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.bedBath}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="DollarSign" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.price}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="Wifi" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.internetInc}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="Car" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.parkingInc}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="Sun" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.poolInc}
              </div>
              <div className="flex items-center text-lg md:text-xl text-slate-200">
                <SafeIcon name="CheckSquare" className="w-5 h-5 mr-3 text-brand-light" />
                {t.hero.laundryInc}
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-4">
              <a 
                href="#contact" 
                onClick={(e) => { 
                  e.preventDefault(); 
                  trackContact('Check Availability');
                  scrollTo('contact'); 
                }} 
                className="btn-primary text-lg px-8 py-4 text-center"
              >
                {t.hero.checkAvail}
              </a>
              <a 
                href="https://www.google.com/maps/dir/?api=1&destination=7429%20NW%20182nd%20St%2C%20Hialeah%2C%20FL%2033015" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label={t.hero.directionsAria}
                onClick={() => trackContact('Get Directions')}
                className="btn-primary bg-brand text-white border-brand hover:bg-brand-dark hover:border-brand-dark backdrop-blur-sm text-lg px-8 py-4 flex items-center justify-center"
              >
                <SafeIcon name="MapPin" className="mr-2 w-5 h-5 flex-shrink-0" />
                {t.hero.directions}
              </a>
              <div className="flex gap-2 w-full sm:w-auto">
                <a 
                  href="tel:+17865291915" 
                  onClick={() => trackContact('Call')} 
                  className="btn-secondary bg-white/10 text-white border-white/20 hover:bg-white/20 hover:border-white/30 backdrop-blur-sm flex-1 sm:flex-none justify-center"
                >
                  <SafeIcon name="Phone" className="mr-2 w-5 h-5 flex-shrink-0" />
                  {t.hero.callNow}
                </a>
                <a 
                  href="sms:+17865291915" 
                  onClick={() => trackContact('Text')} 
                  className="btn-secondary bg-white/10 text-white border-white/20 hover:bg-white/20 hover:border-white/30 backdrop-blur-sm flex-1 sm:flex-none justify-center"
                >
                  <SafeIcon name="MessageSquare" className="mr-2 w-5 h-5 flex-shrink-0" />
                  {t.hero.sendText}
                </a>
              </div>
            </div>
            
            <div className="mt-6 flex flex-col gap-2">
              <p className="text-slate-300 text-sm drop-shadow-sm flex items-center">
                <SafeIcon name="MapPin" className="w-4 h-4 mr-2 opacity-80" />
                {t.hero.address}
              </p>
              <p className="text-slate-300 text-sm drop-shadow-sm flex items-center">
                <SafeIcon name="Phone" className="w-4 h-4 mr-2 opacity-80" />
                786-529-1915
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;